import { useParams } from "react-router-dom";

export function useLocalePath() {
  const { locale } = useParams();
  return `/${locale || "en"}`;
}
